export const ALL_STUDENTS = 0;

export const BRONZE_CERT_TYPE = 'bronze';
export const SILVER_CERT_TYPE = 'silver';
export const GOLD_CERT_TYPE = 'gold';
export const PLATINUM_CERT_TYPE = 'platinum';
export const EMERALD_CERT_TYPE = 'emerald';
export const DIAMOND_CERT_TYPE = 'diamond';
export const EPIC_CERT_TYPE = 'epic';
export const LEGEND_CERT_TYPE = 'legend';

export const BRONZE_CERT_TYPE_PAST = 'bronzePast';
export const SILVER_CERT_TYPE_PAST = 'silverPast';
export const GOLD_CERT_TYPE_PAST = 'goldPast';
export const ALL_CERTS_TYPE = 'All';

export const CERT_VALUES = {
    [BRONZE_CERT_TYPE]: 1,
    [SILVER_CERT_TYPE]: 2,
    [GOLD_CERT_TYPE]: 3,
    [PLATINUM_CERT_TYPE]: 4,
    [EMERALD_CERT_TYPE]: 5,
    [DIAMOND_CERT_TYPE]: 6,
    [EPIC_CERT_TYPE]: 7,
    [LEGEND_CERT_TYPE]: 8,
    [GOLD_CERT_TYPE_PAST]: 3,
    [SILVER_CERT_TYPE_PAST]: 2,
    [BRONZE_CERT_TYPE_PAST]: 1,
    [ALL_CERTS_TYPE]: 0
};




// WEBPACK FOOTER //
// ./containers/certificates/certificates-constants.js